export default {"src":"/_next/static/media/Grow Icon.5edcb4e4.svg","height":52,"width":63};